import {ScrollSync, AutoSizer, Grid} from "react-virtualized";
import DatePicker from "react-datepicker";
import TimeInput from "time-input";
import moment from "moment";
import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import styles from "./table.scss";

var DataService = require('../../../../core/services/data-service/data-service.js');
var Controller = require('./controller.js');
// var Preloader = require('../../../../../../components/common/preloader.jsx');

export default class TableWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      rowCount: 0,
      editRow: [],
      dateForNewRow: moment(),
      timeForNewRow: moment().format("HH:mm:ss:SSS"),
      editRowEnabled: false
    }
  }

  componentWillMount() {
    this.editRow = [];
    this.list = [];
    this.componentId = this.props.componentId;
    this.controller = new Controller(this.props.componentId, this.props.legends);
    this.setColumns();
    this.isRealtime = true;
    this.snapshotRequestd = false;
    this.rowHeight = 35;
    this.initialSnapshotReceived = false;
  }

  setColumns() {
    this.columns = [{name: "Timestamp", fieldId: "timestamp"}];
    this.editRow.push({fieldId: "timestamp"});
    for (let i = 0; i < this.props.legends[0].parameters.columns.length; i++) {
      let column = this.props.legends[0].parameters.columns[i];
      if (column.fieldId === "timestamp") continue;
      if (column.name != null && column.activated) {
        this.columns.push(column);
        this.editRow.push(column);
      }
    }
  }

  componentDidMount() {
    this.subscribe(InternalEvent.Widget.REALTIME_RESUMED, this.resetWidget);
    this.controller.addUpdateListener(this.update);
    WidgetService.addComponentToWidget(this.props.widgetId, this.controller);
  }

  componentWillUnmount() {
    this.controller.destroy();
    this.unsubscribeAll();
  }

  resetWidget(data) {
    if (this.props.widgetId === data.widgetId) {
      this.publish(InternalEvent.Dashboard.CHART_RESET, {
        widgetId: this.props.widgetId,
        type: this.props.model.type,
        title: this.props.model.title,
        legends: this.props.model.legends,
        maximized: data.maximized
      })
    }
  }

  update(newData) {
    if (this.initialSnapshotReceived == false) {
      this.initialSnapshotReceived = true;
      for (let i = 0; i < newData.length; i++) {
        this.list.unshift(newData[i]);
      }
      this.setState({
        rowCount: this.list.length
      });
      if (this.props.isPreviewWidget) {
        this.isRealtime = false;
      }
    } else if (this.isRealtime) {
      this.list.unshift(newData);
      this.optimizeCache();
      this.setState({
        rowCount: this.list.length
      });
    }

    if (this.list.length > 0) {
      $(".grid-header").css("overflow-x", "hidden");
    }
  }

  optimizeCache() {
    if (this.list.length > 1000000) {
      this.list.splice(900000, 100000);
    }
  }

  handleChange(columnIndex) {
    let _this = this;
    return function (event) {
      _this.editRow[columnIndex].value = event.target.value;
    }
  }

  cellRenderer(payload) {
    let fieldId = this.getColumnNameByIndex(payload.columnIndex);
    let value = this.list[payload.rowIndex][fieldId];
    if (fieldId === "timestamp") {
      let t = moment(value);
      value = <div>
        <span>{t.format("MM/DD/YYYY")}</span>
        <span>{t.format("HH:mm:ss.SSS")}</span>
      </div>;
    } else {
      value = value != null ? value.toString() : "";
    }
    return (
      <div className="grid-main__cell" key={payload.key} style={payload.style}>
        {value}
      </div>
    )
  }

  headerRenderer(payload) {
    let value, classes = "grid-header__cell";
    if (payload.rowIndex === 1) {
      classes = "grid-header__cell grid-header__cell--editable";
      if (payload.columnIndex === 0) {
        value = <div className="table-widget-datetime-picker">
          <DatePicker
            selected={this.state.dateForNewRow}
            onChange={this.handleDateChange}/>
          <TimeInput value={this.state.timeForNewRow} onChange={this.handleTimeChange}/>
        </div>;
      } else {
        if (this.editRow.length > 0) {
          value = <div>
            <input type="text" className="new-row-input" defaultValue={this.editRow[payload.columnIndex].value}
                   onChange={this.handleChange(payload.columnIndex)}/>
          </div>;
        } else {
          value = <div></div>;
        }
      }
    } else {
      value = <span> {this.columns[payload.columnIndex].name}</span>;
    }
    return (
      <div className={classes} key={payload.key} style={payload.style}>
        {value}
      </div>
    )
  }

  handleDateChange(date) {
    this.setState({
      dateForNewRow: date
    });
  }

  handleTimeChange(time) {
    this.setState({
      timeForNewRow: time
    });
  }

  getColumnNameByIndex(index) {
    return this.columns[index].fieldId;
  }

  getColumnWidth(containerWidth) {
    let scrollbarSize = 17;
    let width = (containerWidth - scrollbarSize) / this.columns.length;
    return width < 120 ? 120 : width;
  }

  onScroll(payload) {
    if (this.isRealtime) {
      if (payload.scrollTop > 0) {
        this.isRealtime = false;
        this.publish(InternalEvent.Widget.HISTORY_MODE_TOGGLED, {
          widgetId: this.props.widgetId,
          value: true
        });
      }
    } else {
      if ((payload.clientHeight + payload.scrollTop) / payload.scrollHeight > 0.9) {
        this.loadSnapshotData(this.getVisibleRowCount(payload.clientHeight));
      }
    }
  }

  getVisibleRowCount(height) {
    return parseInt(height / this.rowHeight);
  }

  loadSnapshotData(rowCount) {
    if (this.snapshotRequestd || this.isEndOfData) return;
    this.snapshotRequestd = true;
    let lastData = this.list[this.list.length - 1];
    let datasetId;
    for (let key in this.props.legends[0].mappings) {
      datasetId = this.props.legends[0].mappings[key].datasetId;
    }
    let eventId = lastData.eventId.replace(/-/g, "");
    let fileBlockIndex = parseInt("0x" + eventId.substr(0, 16));
    let fileBlockRecordIndex = parseInt("0x" + eventId.substr(16, 32));

    DataService.getDataByRecordLocation(datasetId, fileBlockIndex, fileBlockRecordIndex, 1, rowCount)
      .then(snapshotData => {
        let data = snapshotData.data;
        if (data.length > 0) {
          this.snapshotRequestd = false;
          for (let i = data.length - 1; i >= 0; i--) {
            this.list.push(data[i]);
          }
          this.setState({
            rowCount: this.list.length
          });
        } else {
          this.isEndOfData = true;
        }
      });

  }

  resetEditRow() {
    this.setState({
      dateForNewRow: moment(),
      timeForNewRow: moment().format("HH:mm:ss:SSS")
    });

    let inputs = $(".new-row-input");
    for (let i = 0; i < inputs.length; i++) {
      this.editRow[i].value = "";
      $(inputs[i]).val("");
    }
  }

  publishData(event) {
    let dateTimeString = this.state.dateForNewRow.format("YYYY-MM-DD") + " " + this.state.timeForNewRow;
    let dateTime = moment(new Date(dateTimeString));
    let data = {};
    data.timestamp = dateTime.valueOf();
    for (let i = 0; i < this.editRow.length; i++) {
      if (this.editRow[i].value != null && this.editRow[i].value.length > 0) {
        switch (this.editRow[i].valueType) {
          case 1:
          case 2: {
            data[this.editRow[i].fieldId] = parseFloat(this.editRow[i].value);
            break;
          }
          case 4:
          case 5:
          case 6: {
            data[this.editRow[i].fieldId] = parseInt(this.editRow[i].value);
            break;
          }
          default: {
            data[this.editRow[i].fieldId] = this.editRow[i].value;
          }
        }
      }
    }
    DataService.publishData(this.props.dataset.datasetId, this.props.dataProfile, data, function () {
    });
    this.resetEditRow();

    data.timestamp = dateTime.valueOf();
    this.list.unshift(data);
    this.setState({
      rowCount: this.list.length
    });
    $(".grid-header").css("overflow-x", "hidden");
  }

  toggleEditRow(event) {
    let editRowEnabled = false;
    if ($(event.target).hasClass("icon-plus")) {
      $(event.target).removeClass("icon-plus").addClass("icon-minus");
      editRowEnabled = true;
    } else {
      $(event.target).removeClass("icon-minus").addClass("icon-plus");
      editRowEnabled = false;
    }
    this.setState({
      editRowEnabled: editRowEnabled
    });
  }

  render() {
    let _this = this;
    let configBtn, publishActions;
    let headerGridCustomStyle = {
      overflowX: "auto"
    }, mainGridCustomStyle = {}, actionStyle = {};
    let headerGridHeight = 57;
    let containerStyle = {
      height: "calc(100% - 9px)",
      paddingTop: "20px"
    };

    if (this.props.isPreviewWidget) {
      configBtn = <div className="table-actions">
        <i className="icon-action-redo table-actions__field-toggle"
           onClick={() => this.props.openSideNav("copyDashboardSidenav")}/>
        <i className="icon-menu table-actions__field-toggle" onClick={() => this.props.openSideNav("dataProfileSideNav")}/>
        <i className="icon-plus table-actions__edit-row-toggle" onClick={this.toggleEditRow}/>
      </div>;
      containerStyle.paddingRight = "30px";
    } else if (this.props.isAddWidget) {
      configBtn = <div className="table-actions">
        <i className="material-icons table-actions__field-toggle" onClick={() => this.props.openSideNav("dataProfileSideNav")}>menu</i>
      </div>;
      containerStyle.paddingRight = "30px";
    }

    if (this.state.editRowEnabled) {
      headerGridHeight = 80;
      if (this.state.rowCount == 0) {
        headerGridHeight = 97;
        headerGridCustomStyle.overflowX = "auto";

      }
      mainGridCustomStyle = {
        backgroundColor: "white"
      };

      publishActions = <div className="publish-actions" style={actionStyle}>
        <a className="publish-actions__reset" onClick={this.resetEditRow}>Reset</a>
        <a className="publish-actions__publish" onClick={this.publishData}>Publish</a>
      </div>;
    } else {
      if (this.state.rowCount > 0) {
        headerGridHeight = 40;
      }
    }

    return (
      <div id={this.componentId} style={containerStyle}>
        <ScrollSync>
          {({clientHeight, clientWidth, onScroll, scrollHeight, scrollLeft, scrollTop, scrollWidth}) => (
            <AutoSizer disableWidth>
              {({width, height}) => (
                <div>
                  <Grid
                    cellRenderer={this.headerRenderer}
                    columnCount={this.columns.length}
                    columnWidth={this.getColumnWidth(width)}
                    className="grid-header"
                    height={headerGridHeight}
                    rowCount={this.state.editRowEnabled ? 2 : 1}
                    rowHeight={40}
                    onScroll={onScroll}
                    scrollLeft={scrollLeft}
                    width={width - 17}
                    style={headerGridCustomStyle}>
                  </Grid>
                  {publishActions}
                  <Grid
                    cellRenderer={this.cellRenderer}
                    columnCount={this.columns.length}
                    columnWidth={this.getColumnWidth(width)}
                    className="grid-main"
                    height={this.state.editRowEnabled ? height - 110 : height - 40}
                    rowCount={this.state.rowCount}
                    onScroll={function (payload) {
                      onScroll(payload);
                      _this.onScroll(payload);
                    }}
                    scrollLeft={scrollLeft}
                    rowHeight={this.rowHeight}
                    width={width} style={mainGridCustomStyle}>
                  </Grid>
                </div>
              )}
            </AutoSizer>
          )}
        </ScrollSync>
        {configBtn}
        {/*<Preloader classes="table-widget-preloader" ref="preloader"/>*/}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/table/tableWidget.jsx